<template>
    <main>
        <slot />
    </main>
</template>

<script>
export default {
    name: 'app',
    created () {
        if (!this.$store.getters.portfolio.loaded) {
            this.$store.dispatch('getPortfolio')
        }
    },
}
</script>

<style lang="scss">
    @import '../assets/scss/main.scss';

</style>



// WEBPACK FOOTER //
// src/layouts/CategoryLayout.vue